



























































































































































































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,GetPatientVascularAccessList,DialysNurse,GetDialysNurses,GetDlyCompDics,GetDialysNurseList} from '../../../api/dialysisProcess'
import dialysisNurseForm from './dialysisNurseForm'
import ECharts from 'vue-echarts'
import uploadImg from '../../../components/upload/dialysisBeginUploadImg.vue'

@Component({
    components:{ECharts,uploadImg}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    created(){
      
    }
    form:any = new dialysisNurseForm()

    //左右tabs
    tabsShow = 1
    //医嘱选择
    adviceType = 1

    piclist:any = {}
    picConfirm(list:any){
        let paths = list.map((item:any)=>{
            return item.path
        })
        this.form.patientVaEvent.imagePath = paths.join(',')
    }
    //表单值
    rules = {};
    async save(){
        let list = this.reasonOptions.length>=this.handleOptions.length?this.reasonOptions:this.handleOptions
        this.form.patientVaEvent.items = []
        this.form.patientVaEvent.patientId = this.data.patientId
        this.form.patientVaEvent.patientVAId = 1
        list.forEach((item:any,index:any) => {
            this.form.patientVaEvent.items.push({
                reasonType:this.reasonOptions[index]?this.reasonOptions[index].reasonType:null,
                reasonDeclare:this.reasonOptions[index]?this.reasonOptions[index].reasonDeclare:null,
                handleType:this.handleOptions[index]?this.handleOptions[index].handleType:null,
                handleDeclare:this.handleOptions[index]?this.handleOptions[index].handleDeclare:null,
                remarks:null,
            })
        });
        // let res = await RecordDlyComp(this.form)
        // if(res.status == 1){
        //     this.getDlyComps()
        // }


        this.form.recipeId = this.data.recipeId;
        let data = this.form;


        let res = await DialysNurse(data)
        if(res.status==1){
            this.$emit('input',false);
            this.$emit('on-back')
        }
    }

    //确认处方
   
    mounted() {
        this.getPatientVascularAccessList()
        this.getDialysNurses()
        this.getDlyCompDics()
        this.getDialysNurseList()
    }
    accessList = []
    //获取通路事件
    async getPatientVascularAccessList(){
        let data = {
            PatientId:1
        }
        let res = await GetPatientVascularAccessList(data)
        this.accessList = res.objects
    }
    compDicsOptions:any = []
    async getDlyCompDics(){
        let data = {
            Catagroy:2
        }
        let res = await GetDlyCompDics(data)
        this.compDicsOptions = res.objects
        console.log(res)
    }
    handleItems:any = []
    reasonItems:any = []

    handleOptions:any = []
    reasonOptions:any = []

    reasonTypes:any = []
    handleTypes:any = []
    compDicsChange(){
        this.compDicsOptions.forEach((item:any) => {
            if(this.form.patientVaEvent.complication == item.complication){
                this.handleItems = item.handleItems
                this.reasonItems = item.reasonItems
            }
        });
    }
    //原因选择
    reasonChange(){
        let oldreasonOptions = this.reasonOptions;
        console.log(this.reasonTypes)
        this.reasonOptions = []
        this.reasonTypes.forEach((element:any) => {
            let oldItem = oldreasonOptions.find((v:any)=>{return v.reasonType==element});
            console.log(oldItem)
            this.reasonOptions.push({
                reasonType:element,
                reasone:this.reasonItems.find((v:any)=>{return v.reasonType==element}).reason,
                handle:null,
                reasonDeclare:oldItem?oldItem.reasonDeclare:'',
                handleType:null,
                handleDeclare:null,
                remarks:null,
            })
        });
        
    }
    //处理选择
    handleChange(){
        let oldhandleOptions = this.handleOptions;
        this.handleOptions = []
        this.handleTypes.forEach((element:any) => {
            let oldItem = oldhandleOptions.find((v:any)=>{return v.handleType==element});
            this.handleOptions.push({
                reasonType:null,
                handle:this.handleItems.find((v:any)=>{return v.handleType==element}).handle,
                reasone:null,
                reasonDeclare:null,
                handleType:element,
                handleDeclare:oldItem?oldItem.handleDeclare:'',
                remarks:null,
            })
        });
        
    }
    compEdit(row:any){
        this.form = Object.assign({},row)
        this.compDicsChange()
        this.handleOptions = []
        this.reasonOptions = []
        row.patientVaEvent.items.forEach((item:any)=>{
            if(item.handleType){
                this.handleOptions.push({
                    reasonType:null,
                    handle:this.handleItems.find((v:any)=>{return v.handleType==item.handleType}).handle,
                    reasone:null,
                    reasonDeclare:null,
                    handleType:item.handleType,
                    handleDeclare:item.handleDeclare,
                    remarks:null,
                })
                this.handleTypes.push(item.handleType)
            }
        })
        row.patientVaEvent.items.forEach((item:any)=>{
            if(item.reasonType){
                this.reasonOptions.push({
                    reasonType:item.reasonType,
                    handle:null,
                    reasone:this.reasonItems.find((v:any)=>{return v.reasonType==item.reasonType}).reason,
                    reasonDeclare:item.handleDeclare,
                    handleType:null,
                    handleDeclare:null,
                    remarks:null,
                })
                this.reasonTypes.push(item.reasonType)
            }
            
        })
    }
    
    async getDialysNurseList(){
        let data = {
            RecipeId:this.data.recipeId
        }
        let res = await GetDialysNurseList(data)
        this.compList = res.objects

        this.handleOptions = []
        this.reasonOptions = []
        this.handleTypes = []
        this.reasonTypes = []

    }
    compList:any = []
    compColumn = [
        {
            title:'发生日期',
            key:'recordTime',
            render: (h: any, params: any) => {
                return h('span',this.formatDateTime(params.row.recordTime))
            }
        },
        {
            title:'创建人',
            key:'creatorUser',
        },
        {
            title:'并发症',
            key:'complicationName',
            render: (h: any, params: any) => {
                return h('span',params.row.patientVaEvent?params.row.patientVaEvent.complicationName:'')
            }
        },
        {
            title:'内容',
            key:'content',
        },
        {
            title:'说明',
            key:'declare',
        },
        {
            title: this.L('Actions'),
            key: 'Actions',
            width: 80,
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.compEdit(params.row)
                            }
                        }
                    }, '编辑'),
                   
                ])
            }
        }
        
    ]


    
    cancel(){
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    //全程数据图表
    async getDialysNurses(){
        let data = {
            RecipeId:this.data.recipeId
        }
        let res = await GetDialysNurses(data)
        this.nursesHisData = res.objects
        this.nursesChange(0)
    }
    nursesHisData:any = []
    nursesType:any = ['血压','心率','呼吸','血流量','跨膜压','静脉压','动脉压','电导度','超滤量','超滤率','透析液流量','透析液温度']
    nursesActive = 0
    nursesChange(index:any){
        this.nursesActive = index
        let categoryData = this.nursesHisData.map((item:any)=>{
            return this.formatTime(item.recordTime)
        })
        let valueData = [];
        let legendName = [];
        if(this.nursesActive==0){
            //血压双x轴
            let value1 = this.nursesHisData.map((item:any)=>{
                return item.systolicPressure
            })
            let value2 = this.nursesHisData.map((item:any)=>{
                return item.diastolicPressure
            })
            valueData = [value1,value2];
            legendName = ['收缩压','舒张压'];
        }else{
            let value;
            legendName = [this.nursesType[this.nursesActive]];
            switch(this.nursesActive){
                case 1:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.heartRate
                    })
                break;
                case 2:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.respiratoryRate
                    })
                break;
                case 3:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.bfv
                    })
                break;
                case 4:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.transmembranePressure
                    })
                break;
                case 5:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.venousPressure
                    })
                break;
                case 6:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.arterialPressure
                    })
                break;
                case 7:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.conductivity
                    })
                break;
                case 8:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.ufv
                    })
                break;
                case 9:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.ufr
                    })
                break;
                case 10:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.diaFlow
                    })
                break;
                case 11:
                    value = this.nursesHisData.map((item:any)=>{
                        return item.diaTemperature
                    })
                break;
            }
            valueData = [value];
        }
        this.createdCharts(legendName,categoryData,valueData)
    }
    dataE:any = {}
    createdCharts(legendName:any,categoryData:any,valueData:any) {
        this.dataE = {
            legend: {
                data:legendName
            },
            grid: {
                bottom: 60,
                left:80,
                right:80,
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    lineStyle:{
                        color: '#009688',
                        width: 2,
                        type: 'solid'
                    }
                }
            },
            xAxis: {
                data: categoryData,
                silent: false,
                axisTick:{ show:false},
                splitLine: {
                    show: true,
                    lineStyle:{
                        color: '#EBEBEB',
                        width: 1,
                        type: 'solid'
                    }
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#009688',
                        width: '2' 
                    }
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis:this.fillyAxis(legendName),
            series:this.fillSeries(legendName,valueData)
        };

    }
    fillyAxis(legendName:any){
        let yAxis:any = []
        legendName.forEach((item:any,index:number) => {
            yAxis.push({
                splitArea: {
                    show: true,
                    areaStyle:{
                        color:['#FFFFFF','#F9F9F9']
                    }
                },
                axisTick:{ show:false},
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#009688',
                        width: '2' 
                    }
                },
                splitNumber:5,
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#000'
                    }
                }
            })
        });
        return yAxis;
    }
    fillSeries(legendName:any,valueData:any){
        let series:any = []
        legendName.forEach((item:any,index:number) => {
            series.push({
                type: 'line',
                name:item,
                data: valueData[index],
                large: true,
                smooth:true,
                color:index==0?'#009688':'#5cadff'
            })
            
        });
        return series;
    }
    
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/dialysisNurse.vue